import { LAST_POINT_DOT_RADIUS_PX } from "../constants";

const FULL_CIRCLE = Math.PI * 2;

/**
 * Dot on the last point of the Line chart (04-line-area.jpg), clipped to the pane.
 *
 * @param {object} textLayer
 * @param {object} params
 * @param {{ index: number, price: number, color: { css: string } }} params.lastValue - mainSeries.lastValue
 * @param {object} params.timeScale
 * @param {object} params.priceScale
 * @param {{ width: number, height: number }} params.pane
 */
export const drawLastPointDot = (textLayer, { lastValue, timeScale, priceScale, pane }) => {
  const { context } = textLayer;

  context.save();
  context.beginPath();
  context.rect(0, 0, pane.width, pane.height);
  context.clip();
  context.beginPath();
  context.arc(
    timeScale.indexToX(lastValue.index),
    priceScale.priceToY(lastValue.price),
    LAST_POINT_DOT_RADIUS_PX,
    0,
    FULL_CIRCLE,
  );
  context.fillStyle = lastValue.color.css;
  context.fill();
  context.restore();
};
